import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { Form, Input, Icon, Drawer, Checkbox, Select, InputNumber, notification, Radio } from "antd";
import axios from "axios";

import DrawerFicha from "./DrawerFicha";
import DrawerHabilidades from "../../../../features/Turmas/Componentes/Drawers/DrawerHabilidades";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerDisciplina = ({ turmaId, disciplinaId, visible, onClose, atualizar, form }) => {
    const [formData, setFormData] = useState({
        nome: "",
        codigo: "",
        creditos: 1,
        horas_trabalho: 1,
        carga_horaria: 1,
        horas_contacto: [],
        fasesEscolares: [],
        //FICHAS
        fichaId: undefined,
        fichaCampos: [],
        encerramento: "Manual",
        percentagemFaltas: 0,
        tipoDisciplina: 1,
        ordem: 1,
        horas_trabalho: "01h",
        habilitarConteudosStepforma: false,
        atividadeConteudosStepforma: undefined,
        //BNCC
        modoBnccSelecionado: "livre",
        subModoBnccSelecionado: "porDisciplina",
        bnccAnos: [],
        bnccDisciplinas: [],
        bnccPeriodos: []
    });
    const [modalHabilidades, setModalHabilidades] = useState({
        visible: false,
        periodoId: null,
        habilidadesGuardadas: []
    });
    const [habilidades, setHabilidades] = useState([]);
    const [estruturaStatus, setEstruturaStatus] = useState({
        validateStatus: "",
        help: ""
    });

    const [listaAtividadesConteudosStepforma, setListaAtividadesConteudosStepforma] = useState([]);

    const [tiposHoras, setTiposHoras] = useState([]);
    const [tiposDiario, setTiposDiario] = useState([]);
    const [fichas, setFichas] = useState([]);
    const [visibleFicha, setVisibleFicha] = useState(false);
    const [loading, setLoading] = useState(false);

    const { getFieldDecorator } = form;
    const { Option } = Select;

    const handleChangeCheckbox = event => {
        const { name, checked } = event.target;

        setFormData(prevState => ({
            ...prevState,
            [name]: checked
        }));
    };

    const handleChangeHorasContacto = (value, index) => {
        let horas_contacto = formData.horas_contacto;
        horas_contacto[index].id = value;
        setFormData({ ...formData, horas_contacto });
    };

    const handleChangeHorasContactoCarga = (value, index) => {
        let horas_contacto = formData.horas_contacto;
        horas_contacto[index].carga_horaria = value;
        setFormData({ ...formData, horas_contacto });
    };

    const excluirHorasContacto = index => {
        form.resetFields();
        let horas_contacto = formData.horas_contacto;
        horas_contacto.splice(index, 1);
        setFormData({ ...formData, horas_contacto });
    };

    const handleChangeFase = (value, index) => {
        const fase = tiposDiario.find(x => x.id === value);

        let fasesEscolares = formData.fasesEscolares;

        fasesEscolares[index].tipo = value;
        fasesEscolares[index].periodo = fase.periodo_letivo;
        fasesEscolares[index].genero = fase.tipo;

        setFormData({ ...formData, fasesEscolares });
    };

    const handleChangeFaseOrdem = (value, index) => {
        let fasesEscolares = formData.fasesEscolares;

        fasesEscolares[index].ordem = value;

        setFormData({ ...formData, fasesEscolares });
    };

    const handleChangeModoBncc = e => {
        setFormData(prev => ({
            ...prev,
            modoBnccSelecionado: e.target.value,
            habilidades: []
        }));
    };

    const handleChangeSubModoBncc = e => {
        setFormData(prev => ({
            ...prev,
            subModoBnccSelecionado: e.target.value
        }));
        setHabilidades([]);

        carregarPeriodos();
    };

    const excluirCampo = index => {
        form.resetFields();
        let fasesEscolares = formData.fasesEscolares;
        fasesEscolares.splice(index, 1);

        setFormData({ ...formData, fasesEscolares });
    };

    const listarAtividadesConteudosStepforma = novo => {
        axios({
            method: "get",
            url: "/api/gestao-cursos/listar-atividades-conteudos-stepforma",
            params: {
                cursoId: disciplinaId,
                novo
            }
        })
            .then(response => {
                setListaAtividadesConteudosStepforma(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const detalhe = () => {
        listarAtividadesConteudosStepforma(false);
        axios({
            method: "get",
            url: "/api/gestao-templates-turmas/detalhe-disciplina",
            params: {
                disciplinaId
            }
        })
            .then(response => {
                var info = response.data;
                let horas_contacto = [];

                info.horas_Contacto.forEach(hora_contacto => {
                    horas_contacto.push({
                        id: hora_contacto.id_tipo_hora,
                        carga_horaria: hora_contacto.carga_horaria
                    });
                });

                const fasesEscolares = info.fasesEscolares.map((fase, index) => {
                    return {
                        id: fase.id,
                        tipo: fase.tipo,
                        periodo: fase.periodo,
                        genero: fase.genero,
                        ordem: fase.ordem
                    };
                });

                setFormData({
                    nome: info.nome,
                    codigo: info.codigo,
                    creditos: info.creditos,
                    horas_trabalho: info.horas_trabalho,
                    carga_horaria: info.carga_horaria,
                    horas_contacto,
                    fasesEscolares,
                    fichaId: info.id_ficha,
                    fichaCampos: JSON.parse(info.ficha_campos),
                    encerramento: info.encerramento,
                    percentagemFaltas: info.limite_percentagem_falta,
                    tipoDisciplina: info.id_tipo_disciplina,
                    ordem: info.ordem,
                    bnccAnos: info.bncc_anos ? info.bncc_anos.split(";") : [],
                    bnccDisciplinas: info.bncc_disciplinas ? info.bncc_disciplinas.split(";") : [],
                    habilitarConteudosStepforma: info.conteudos_stepforma,
                    modoBnccSelecionado: info.modo_bncc,
                    subModoBnccSelecionado: info.sub_modo_bncc,
                    atividadeConteudosStepforma: info.id_atividade_conteudos_stepforma
                });

                if (info.sub_modo_bncc === "porPeriodo") carregarPeriodos();

                setHabilidades(info.habilidades || []);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const validarDuplicados = () => {
        var valueArr = formData.fasesEscolares.map(function (item) {
            return item.tipo;
        });
        var isDuplicate = valueArr.some(function (item, idx) {
            return valueArr.indexOf(item) != idx;
        });

        return isDuplicate;
    };

    const adicionar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (err || formData.fasesEscolares.length === 0) {
                setEstruturaStatus({
                    validateStatus: "error",
                    help: "Campo obrigatório"
                });
                return null;
            }

            if (validarDuplicados()) {
                openNotificationWithIcon("error", "Erro", "Estruturas de avaliação selecionadas em duplicado");

                return null;
            }

            const fasesEscolares = formData.fasesEscolares.map(fe => ({
                id: fe.id,
                tipo: fe.tipo,
                periodo: fe.periodo,
                genero: fe.genero,
                ordem: fe.ordem
            }));

            setLoading(true);
            var item = new FormData();
            item.append("id_template_turma", turmaId);
            item.append("nome", formData.nome.trim());
            item.append("codigo", formData.codigo);
            item.append("creditos", formData.creditos);
            item.append("horas_trabalho", formData.horas_trabalho);
            item.append("carga_horaria", formData.carga_horaria);
            item.append("horas_contacto", JSON.stringify(formData.horas_contacto));
            item.append("fasesEscolares", JSON.stringify(fasesEscolares));
            if (formData.fichaId) {
                item.append("fichaId", formData.fichaId);
                item.append("fichaCampos", JSON.stringify(formData.fichaCampos));
            }
            item.append("encerramento", formData.encerramento);
            item.append("percentagemFaltas", formData.percentagemFaltas);
            item.append("id_tipo_disciplina", formData.tipoDisciplina);
            item.append("ordem", formData.ordem);

            item.append("conteudos_stepforma", formData.habilitarConteudosStepforma);
            if (formData.atividadeConteudosStepforma) item.append("id_atividade_conteudos_stepforma", formData.atividadeConteudosStepforma);

            const bnccAnos = Array.isArray(formData.bnccAnos) ? formData.bnccAnos : [];
            const bnccDisciplinas = Array.isArray(formData.bnccDisciplinas) ? formData.bnccDisciplinas : [];

            if (bnccAnos.length > 0) item.append("bncc_anos", bnccAnos.join(";"));
            if (bnccDisciplinas.length > 0) item.append("bncc_disciplinas", bnccDisciplinas.join(";"));

            item.append("modo_bncc", formData.modoBnccSelecionado);
            item.append("sub_modo_bncc", formData.subModoBnccSelecionado);

            if (habilidades.length) item.append("habilidades", JSON.stringify(habilidades));

            axios({
                method: "post",
                url: "/api/gestao-templates-turmas/adicionar-disciplina",
                data: item
            })
                .then(() => {
                    openNotificationWithIcon("success", "Sucesso", "Disciplina adicionada com sucesso!");
                    setLoading(false);
                    atualizar();
                })
                .catch(error => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível adicionar a disciplina.");
                    setLoading(false);
                });
        });
    };

    const alterar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (err || formData.fasesEscolares.length === 0) {
                setEstruturaStatus({
                    validateStatus: "error",
                    help: "Campo obrigatório"
                });
                return null;
            }

            if (validarDuplicados()) {
                openNotificationWithIcon("error", "Erro", "Estruturas de avaliação selecionadas em duplicado");

                return null;
            }

            setLoading(true);

            var item = new FormData();
            item.append("id", disciplinaId);
            item.append("nome", formData.nome.trim());
            item.append("codigo", formData.codigo);
            item.append("creditos", formData.creditos);
            item.append("horas_trabalho", formData.horas_trabalho);
            item.append("carga_horaria", formData.carga_horaria);
            item.append("horas_contacto", JSON.stringify(formData.horas_contacto));
            item.append("fasesEscolares", JSON.stringify(formData.fasesEscolares));
            if (formData.fichaId) {
                item.append("fichaId", formData.fichaId);
                item.append("fichaCampos", JSON.stringify(formData.fichaCampos));
            }
            item.append("encerramento", formData.encerramento);
            item.append("percentagemFaltas", formData.percentagemFaltas);
            item.append("id_tipo_disciplina", formData.tipoDisciplina);
            item.append("ordem", formData.ordem);

            item.append("conteudos_stepforma", formData.habilitarConteudosStepforma);
            if (formData.atividadeConteudosStepforma) item.append("id_atividade_conteudos_stepforma", formData.atividadeConteudosStepforma);

            const bnccAnos = Array.isArray(formData.bnccAnos) ? formData.bnccAnos : [];
            const bnccDisciplinas = Array.isArray(formData.bnccDisciplinas) ? formData.bnccDisciplinas : [];

            if (bnccAnos.length > 0) item.append("bncc_anos", bnccAnos.join(";"));
            if (bnccDisciplinas.length > 0) item.append("bncc_disciplinas", bnccDisciplinas.join(";"));

            item.append("modo_bncc", formData.modoBnccSelecionado);
            item.append("sub_modo_bncc", formData.subModoBnccSelecionado);

            if (habilidades.length) item.append("habilidades", JSON.stringify(habilidades));

            axios({
                method: "put",
                url: "/api/gestao-templates-turmas/alterar-disciplina",
                data: item
            })
                .then(() => {
                    openNotificationWithIcon("success", "Sucesso", "Disciplina alterada com sucesso!");
                    setLoading(false);
                    atualizar();
                })
                .catch(error => {
                    openNotificationWithIcon("error", "Erro", "Não foi possível alterar a disciplina.");
                    setLoading(false);
                });
        });
    };

    const carregarTiposHoras = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/carregar-tipos-horas"
        })
            .then(response => {
                setTiposHoras(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar tipos de horas!");
            });
    };

    const carregarTiposDiario = index => {
        axios({
            method: "get",
            url: "/api/gestao-templates-turmas/lista-tipos-diario",
            params: {
                novo: disciplinaId > 0,
                disciplinaId: disciplinaId
            }
        })
            .then(response => {
                setTiposDiario(response.data);

                if (disciplinaId > 0) detalhe();
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os tipos de diário!");
            });
    };

    const carregarFichas = () => {
        axios({
            method: "get",
            url: "/api/gestao-turmas/listar-fichas"
        })
            .then(response => {
                setFichas(response.data);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a ficha!");
            });
    };

    const adicionarHorasContacto = () => {
        const registo = {
            id: undefined
        };

        setFormData({ ...formData, horas_contacto: [...formData.horas_contacto, registo] });
    };

    const adicionarFaseEscolar = () => {
        const periodos = formData.fasesEscolares.map(fase => fase.periodo);

        const fase = {
            id: "",
            periodos: tiposDiario.filter(x => !periodos.includes(x.periodo_letivo)),
            tipo: undefined,
            periodo: "",
            genero: "",
            ordem: 1
        };

        setEstruturaStatus({
            validateStatus: "",
            help: ""
        });
        setFormData({ ...formData, fasesEscolares: [...formData.fasesEscolares, fase] });
    };

    const carregarPeriodos = () => {
        axios({
            method: "get",
            url: "/api/gestao-templates-turmas/carregar-periodos",
            params: {
                turmaId
            }
        })
            .then(response => {
                setFormData(prev => ({ ...prev, bnccPeriodos: response.data }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar os períodos!");
            });
    };

    const abrirModalHabilidades = () => {
        setModalHabilidades({
            visible: true,
            periodoId: null,
            habilidadesGuardadas: habilidades
        });
    };

    const abrirModalHabilidadesPeriodo = periodoId => {
        var _habilidades = habilidades.filter(h => h.id_periodo === periodoId);

        setModalHabilidades({
            visible: true,
            periodoId,
            habilidadesGuardadas: _habilidades
        });
    };

    const guardarHabilidadesSelecionadas = habilidadesSelecionadas => {
        const _habilidades = habilidadesSelecionadas.map(habilidadeId => {
            return { id_periodo: modalHabilidades.periodoId, id: habilidadeId };
        });

        if (modalHabilidades.periodoId) {
            const outraHabilidades = habilidades.filter(h => h.id_periodo !== modalHabilidades.periodoId);

            setHabilidades([...outraHabilidades, ..._habilidades]);
            setModalHabilidades({ ...modalHabilidades, visible: false });
        } else {
            setHabilidades(_habilidades);
            setModalHabilidades({ ...modalHabilidades, visible: false });
        }
    };

    const afterVisibleChange = visible => {
        form.resetFields();
        if (visible) {
            //if (disciplinaId > 0)
            //    detalhe();

            carregarTiposDiario();
            carregarPeriodos();
            listarAtividadesConteudosStepforma(true);
        } else {
            setFormData({
                nome: "",
                codigo: "",
                creditos: 1,
                horas_trabalho: 1,
                carga_horaria: 1,
                horas_contacto: [],
                fasesEscolares: [],
                //FICHAS
                fichaId: undefined,
                fichaCampos: [],
                encerramento: "Manual",
                percentagemFaltas: 0,
                tipoDisciplina: 1,
                ordem: 1,
                bnccAnos: [],
                bnccDisciplinas: [],
                horas_trabalho: "01h",
                habilitarConteudosStepforma: false,
                atividadeConteudosStepforma: undefined
            });
        }
    };

    const validarValor = (rule, value, callback) => {
        if (isNaN(value)) callback("O valor deve ser um número");

        callback();
    };

    const formatarCargaHoraria = e => {
        const input = e.target.value;

        // Separar partes antes e depois do ':'
        const [horasPart, minutosPart] = input.split(":");

        const horas = horasPart.replace(/\D/g, "");
        let minutos = minutosPart ? minutosPart.replace(/\D/g, "") : "";

        // Limitar minutos a no máximo 2 dígitos
        if (minutos.length > 2) {
            minutos = minutos.slice(0, 2);
        }
        //${minutos}m
        let formatted = "";
        if (input.includes(":")) {
            formatted = `${horas}h:`;
            if (minutos.length >= 1) formatted = `${formatted}${minutos}m`;
        } else {
            formatted = `${horas}h`;
        }

        setFormData({ ...formData, horas_trabalho: formatted });
    };

    useEffect(() => {
        carregarTiposHoras();
        carregarFichas();
    }, []);

    return (
        <>
            <Drawer
                className="drawer-add-cursos"
                width={720}
                onClose={onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-info">
                    <Form className="form-add-curso" layout="horizontal">
                        <Form.Item label="Nome">
                            {getFieldDecorator("nome", {
                                initialValue: formData.nome,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input name="nome" onChange={e => setFormData({ ...formData, nome: e.target.value })} />)}
                        </Form.Item>
                        <Form.Item label="Código">
                            {getFieldDecorator("codigo", {
                                initialValue: formData.codigo,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<Input name="codigo" onChange={e => setFormData({ ...formData, codigo: e.target.value })} />)}
                        </Form.Item>
                        <Form.Item label="Créditos">
                            {getFieldDecorator("creditos", {
                                initialValue: formData.creditos,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<InputNumber name="creditos" min={1} onChange={creditos => setFormData({ ...formData, creditos })} />)}
                        </Form.Item>
                        <Form.Item label="Carga Horária Total">
                            <Input value={formData.horas_trabalho} onChange={formatarCargaHoraria} placeholder="Ex: 5h ou 1234h:56m" />
                        </Form.Item>
                        <Form.Item label="">
                            <div className="bloco-fases-escolares">
                                <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                    Tipos de Horas / Carga Horária
                                    <button className="botao-principal" onClick={adicionarHorasContacto}>
                                        <Icon type="plus" />
                                    </button>
                                </h3>
                                <div className="curso-lista-fases">
                                    {!formData.horas_contacto.length ? <span>Sem dados</span> : null}
                                    {formData.horas_contacto.map((hora_contacto, index) => (
                                        <div key={index} className="item">
                                            <div className="item-inputs">
                                                <Form.Item>
                                                    {getFieldDecorator(`tipo${index}`, {
                                                        initialValue: hora_contacto.id,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "Campo obrigatório"
                                                            }
                                                        ]
                                                    })(
                                                        <Select
                                                            placeholder="Selecionar"
                                                            allowClear={true}
                                                            onChange={value => handleChangeHorasContacto(value, index)}
                                                        >
                                                            {tiposHoras.map(tipo => (
                                                                <Option kye={tipo.id} value={tipo.id}>
                                                                    {tipo.titulo}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    )}
                                                </Form.Item>
                                                <Form.Item>
                                                    {getFieldDecorator(`horas${index}`, {
                                                        initialValue: hora_contacto.carga_horaria,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "Campo obrigatório"
                                                            }
                                                        ]
                                                    })(
                                                        <InputNumber
                                                            name={`horas${index}`}
                                                            min={1}
                                                            onChange={value => handleChangeHorasContactoCarga(value, index)}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </div>
                                            <Link
                                                className="botao-icon-excluir"
                                                to="#"
                                                title="Excluir"
                                                onClick={() => excluirHorasContacto(index)}
                                            >
                                                <Icon type="delete" />
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Form.Item>
                        <Form.Item validateStatus={estruturaStatus.validateStatus} help={estruturaStatus.help}>
                            <div className="bloco-fases-escolares">
                                <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                    Estruturas de Avaliação
                                    <button className="botao-principal" onClick={adicionarFaseEscolar}>
                                        <Icon type="plus" />
                                    </button>
                                </h3>
                                <div className="curso-lista-fases">
                                    {!formData.fasesEscolares.length ? <span>Sem dados</span> : null}
                                    {formData.fasesEscolares.map((faseEscolar, index) => (
                                        <div key={index} className="item">
                                            <div className="item-inputs">
                                                <Form.Item>
                                                    {getFieldDecorator(`fase${index}`, {
                                                        initialValue: faseEscolar.tipo,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "Campo obrigatório"
                                                            }
                                                        ]
                                                    })(
                                                        <Select
                                                            placeholder="Selecionar"
                                                            filterOption={false}
                                                            style={{ width: "100%" }}
                                                            onChange={value => handleChangeFase(value, index)}
                                                        >
                                                            {tiposDiario.map((tipo, index) => (
                                                                <Option key={index} value={tipo.id}>
                                                                    {tipo.nome}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    )}
                                                    {faseEscolar.periodo && faseEscolar.genero && (
                                                        <div
                                                            style={{
                                                                borderTop: "1px solid #d9d9d9",
                                                                marginTop: 10,
                                                                paddingTop: 5,
                                                                display: "flex",
                                                                gap: 10
                                                            }}
                                                        >
                                                            <span style={{ display: "block", lineHeight: "initial" }}>
                                                                Periodo Letivo: <strong>{faseEscolar.periodo}</strong>
                                                            </span>
                                                            <span style={{ display: "block", lineHeight: "initial" }}>
                                                                Tipo: <strong>{faseEscolar.genero}</strong>
                                                            </span>
                                                        </div>
                                                    )}
                                                </Form.Item>
                                                <Form.Item>
                                                    {getFieldDecorator(`fase_ordem${index}`, {
                                                        initialValue: faseEscolar.ordem,
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: "Campo obrigatório"
                                                            }
                                                        ]
                                                    })(
                                                        <InputNumber
                                                            placeholder="Ordem"
                                                            min={1}
                                                            onChange={value => handleChangeFaseOrdem(value, index)}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </div>
                                            <Link className="botao-icon-excluir" to="#" title="Excluir" onClick={() => excluirCampo(index)}>
                                                <Icon type="delete" />
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Form.Item>
                        <Form.Item label="Ficha">
                            {getFieldDecorator("ficha", {
                                initialValue: formData.fichaId
                            })(
                                <>
                                    <Select
                                        placeholder="Selecionar"
                                        value={formData.fichaId}
                                        allowClear={true}
                                        onChange={fichaId => setFormData({ ...formData, fichaId })}
                                    >
                                        {fichas.map((ficha, index) => (
                                            <Option key={index} value={ficha.id}>
                                                {ficha.nome}
                                            </Option>
                                        ))}
                                    </Select>
                                    {formData.fichaId ? (
                                        <Link to="#" onClick={() => setVisibleFicha(true)}>
                                            Preencher ficha
                                        </Link>
                                    ) : null}
                                </>
                            )}
                        </Form.Item>
                        <Form.Item label="Encerramento">
                            {getFieldDecorator("encerramento", {
                                initialValue: formData.encerramento
                            })(
                                <Select placeholder="Selecionar" onChange={encerramento => setFormData({ ...formData, encerramento })}>
                                    <Option value="Manual">Manual</Option>
                                    <Option value="Automatico">Automático</Option>
                                    <Option value="FechoTurma">Fecho da turma</Option>
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item label="% máxima de faltas">
                            {getFieldDecorator("percentagemFaltas", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    },
                                    {
                                        validator: validarValor
                                    }
                                ],
                                initialValue: formData.percentagemFaltas
                            })(
                                <Input
                                    className="input-50"
                                    name="percentagemFaltas"
                                    onChange={e => setFormData({ ...formData, percentagemFaltas: e.target.value })}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Tipo">
                            {getFieldDecorator("tipoDisciplina", {
                                initialValue: formData.tipoDisciplina
                            })(
                                <Select placeholder="Selecionar" onChange={tipoDisciplina => setFormData({ ...formData, tipoDisciplina })}>
                                    <Option value={1}>Base nacional</Option>
                                    <Option value={2}>Parte diversificada</Option>
                                    <Option value={3}>Atividade complementar</Option>
                                    <Option value={4}>Flexibilização</Option>
                                    <Option value={5}>Aprofundamento curricular</Option>
                                    <Option value={6}>Formação geral</Option>
                                </Select>
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Checkbox
                                name="habilitarConteudosStepforma"
                                checked={formData.habilitarConteudosStepforma}
                                onChange={handleChangeCheckbox}
                            >
                                Habilitar Conteúdos Stepforma
                            </Checkbox>
                        </Form.Item>

                        {formData.habilitarConteudosStepforma && (
                            <Form.Item label="Atividades">
                                {getFieldDecorator("listaAtividadesConteudosStepforma", {
                                    initialValue: formData.atividadeConteudosStepforma,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ]
                                })(
                                    <Select
                                        placeholder="Selecionar"
                                        allowClear={true}
                                        onChange={atividadeConteudosStepforma => setFormData({ ...formData, atividadeConteudosStepforma })}
                                    >
                                        {listaAtividadesConteudosStepforma.map((atividade, index) => (
                                            <Option key={index} value={atividade.id}>
                                                {atividade.nome}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        )}
                        <Form.Item label="Ordem">
                            {getFieldDecorator("curso_ordem", {
                                initialValue: formData.ordem,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(
                                <InputNumber
                                    className="input-25"
                                    name="curso_ordem"
                                    min={1}
                                    onChange={ordem => setFormData({ ...formData, ordem })}
                                />
                            )}
                        </Form.Item>
                        <div className="bloco">
                            <h3 className="titulo-separador" style={{ marginBottom: "20px" }}>
                                Habilidades BNCC
                            </h3>
                            <Form.Item>
                                {getFieldDecorator("modoBnccSelecionado", {
                                    initialValue: formData.modoBnccSelecionado
                                })(
                                    <Radio.Group onChange={handleChangeModoBncc}>
                                        <Radio value="filtrar">Selecionar habilidades por ano letivo e disciplina</Radio>
                                        <Radio value="livre">Selecionar habilidades livremente</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                            {formData.modoBnccSelecionado === "filtrar" ? (
                                <>
                                    <Form.Item label="Anos">
                                        {getFieldDecorator("bnccAnos", {
                                            initialValue: formData.bnccAnos
                                        })(
                                            <Checkbox.Group
                                                className="lista-estabelecimentos"
                                                style={{ width: "100%" }}
                                                onChange={bnccAnos => setFormData({ ...formData, bnccAnos })}
                                            >
                                                <div style={{ marginBottom: "20px" }}>
                                                    <Checkbox value="1">1º ano</Checkbox>
                                                    <Checkbox value="2">2º ano</Checkbox>
                                                    <Checkbox value="3">3º ano</Checkbox>
                                                    <Checkbox value="4">4º ano</Checkbox>
                                                    <Checkbox value="5">5º ano</Checkbox>
                                                    <Checkbox value="6">6º ano</Checkbox>
                                                    <Checkbox value="7">7º ano</Checkbox>
                                                    <Checkbox value="8">8º ano</Checkbox>
                                                    <Checkbox value="9">9º ano</Checkbox>
                                                </div>
                                            </Checkbox.Group>
                                        )}
                                    </Form.Item>
                                    <Form.Item label="Disciplinas">
                                        {getFieldDecorator("bnccDisciplinas", {
                                            initialValue: formData.bnccDisciplinas
                                        })(
                                            <Checkbox.Group
                                                className="lista-estabelecimentos"
                                                style={{ width: "100%" }}
                                                onChange={bnccDisciplinas => setFormData({ ...formData, bnccDisciplinas })}
                                            >
                                                <div style={{ marginBottom: "20px" }}>
                                                    <Checkbox value="LP">Língua Portuguêsa</Checkbox>
                                                    <Checkbox value="MA">Matemática</Checkbox>
                                                    <Checkbox value="LI">Língua Inglesa</Checkbox>
                                                    <Checkbox value="HI">História</Checkbox>
                                                    <Checkbox value="GE">Geografia</Checkbox>
                                                    <Checkbox value="ER">Ensino Religioso</Checkbox>
                                                    <Checkbox value="EF">Educação Física</Checkbox>
                                                    <Checkbox value="CI">Ciências</Checkbox>
                                                    <Checkbox value="AR">Artes</Checkbox>
                                                </div>
                                            </Checkbox.Group>
                                        )}
                                    </Form.Item>
                                </>
                            ) : (
                                <>
                                    <Form.Item>
                                        {getFieldDecorator("subModoBnccSelecionado", {
                                            initialValue: formData.subModoBnccSelecionado
                                        })(
                                            <Radio.Group onChange={handleChangeSubModoBncc}>
                                                <Radio value="porDisciplina">Selecionar habilidades para a disciplina</Radio>
                                                <Radio value="porPeriodo">Selecionar habilidades por período</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                    {formData.subModoBnccSelecionado === "porDisciplina" ? (
                                        <div>
                                            <h4
                                                style={{
                                                    color: "#3d464d",
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    marginBottom: 5
                                                }}
                                            >
                                                Habilidades
                                            </h4>
                                            <Link
                                                to="#"
                                                style={{ color: "#f79071" }}
                                                onClick={() => abrirModalHabilidades(formData.disciplinaid)}
                                            >
                                                {habilidades.length > 0
                                                    ? `Ver ${habilidades.length} habilidades selecionadas`
                                                    : "Selecionar habilidades"}
                                            </Link>
                                        </div>
                                    ) : (
                                        <div>
                                            <h4
                                                style={{
                                                    color: "#3d464d",
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    marginBottom: 5
                                                }}
                                            >
                                                Habilidades
                                            </h4>
                                            <ul style={{ paddingLeft: 0, listStyle: "none" }}>
                                                {formData.bnccPeriodos?.map(periodo => (
                                                    <li key={periodo.id} style={{ marginBottom: 8 }}>
                                                        <span>{periodo.nome}</span>
                                                        <Link to="#" onClick={() => abrirModalHabilidadesPeriodo(periodo.id)}>
                                                            {habilidades.filter(h => h.id_periodo === periodo.id).length > 0
                                                                ? `Ver ${
                                                                      habilidades.filter(h => h.id_periodo === periodo.id).length
                                                                  } habilidades selecionadas`
                                                                : "Selecionar habilidades"}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </button>
                    <button className="botao-principal" disabled={loading} onClick={disciplinaId > 0 ? alterar : adicionar} type="primary">
                        {loading ? <Icon type="loading" /> : null}
                        Salvar
                    </button>
                </div>
            </Drawer>
            <DrawerFicha
                fichaId={formData.fichaId}
                fichaCampos={formData.fichaCampos}
                visible={visibleFicha}
                onClose={() => setVisibleFicha(false)}
                atualizar={fichaCampos => {
                    setVisibleFicha(false);
                    setFormData({ ...formData, fichaCampos });
                }}
            />
            <DrawerHabilidades
                visible={modalHabilidades.visible}
                onClose={() => setModalHabilidades(prev => ({ ...prev, visible: false }))}
                periodoId={modalHabilidades.periodoId}
                disciplinaId={disciplinaId}
                habilidadesGuardadas={modalHabilidades.habilidadesGuardadas}
                guardarHabilidadesSelecionadas={guardarHabilidadesSelecionadas}
            />
        </>
    );
};

const FormDrawerDisciplina = Form.create({ name: "form-drawer-disciplina" })(DrawerDisciplina);

export default withRouter(FormDrawerDisciplina);
